module.exports = false;



//////////////////
// WEBPACK FOOTER
// /~/babel-polyfill/~/core-js/modules/_library.js
// module id = 61
// module chunks = 31